import {BrowserRouter} from "react-router-dom";

const history = (new BrowserRouter({})).history; // THIS IS BAD BUT ONLY SOLUTION NOW... NEW TO UPDATE PACKAGES

export default history